<!--
 * @Description: 用户信息防遗忘
-->
<template>
  <div class="perfect_info">
    <NavBar
      :title="$t(`webapp.menus.${$route.meta.field}`)"
      :left-arrow="$route.meta.isShowArrow"
      @click-left="$router.back()"
      nav-bar-icon-color="#000"
      class="navbarSelf"
    ></NavBar>

    <Form class="vertical_self_form" @submit="onSubmit">
      <Field
        v-if="basicSetInfo.fywInfoClassify && basicSetInfo.fywInfoClassify.includes('2')"
        prop="sjh"
        v-model="form.sjh"
        name="sjh"
        :label="$t('base.mobile.label')"
        :placeholder="$t('base.mobile.placeholder')"
        :show-error-message="false"
        :scroll-to-error="true"
        :rules="[{ required: true }, { pattern: /^1[3456789]\d{9}$/, message: $t('base.mobile.error_tip') }]"
      >
      </Field>

      <template v-if="basicSetInfo.fywInfoClassify && basicSetInfo.fywInfoClassify.includes('1')">
        <template v-for="(item, index) in form.questionVos">
          <Field
            readonly
            clickable
            v-model="item.name"
            :key="`qus${index}`"
            :label="`${$t('base.question.label')}${index + 1}`"
            :name="'questionVos.' + index + '.question'"
            :show-error-message="false"
            :scroll-to-error="true"
            :rules="[{ required: true }]"
          >
          </Field>
          <Field
            v-model="item.answer"
            :key="`ans${index}`"
            :label="`${$t('base.question.answer')}${index + 1}`"
            :name="'questionVos.' + index + '.answer'"
            :placeholder="$t('base.question.placeholder')"
            :rules="[{ required: basicSetInfo.aqwt == 1 ? true : false }]"
          >
          </Field>
        </template>
      </template>
      <div style="margin: 30px 0">
        <Button round block type="info" native-type="submit">{{ $t("base.btn.save") }}</Button>
        <Button
          style="margin: 10px 0"
          v-if="basicSetInfo.fywIsSkip == 1"
          round
          block
          native-type="submit"
          @click="forgetPass"
          >{{ $t("base.btn.pass") }}</Button
        >
        <Button round block @click="goLogin">{{ $t("base.btn.back_login") }}</Button>
      </div>
    </Form>
  </div>
</template>

<script>
import { Form, Field, Button, NavBar } from "vant";
import { commonAPI } from "@/apis";
import { commonMethods } from "./mixins/common";
import { toast } from "@/utils/toast";

export default {
  name: "Forgotten",
  components: { Form, Field, Button, NavBar },
  mixins: [commonMethods],
  data() {
    return {
      form: {
        sjh: "",
        questionVos: [],
      },
      basicSetInfo: {},
      before_login: {},
    };
  },
  created() {
    // 获取登录配置
    let basicSetInfo = sessionStorage.getItem("BASIC_SET_INFO");
    this.basicSetInfo = basicSetInfo ? JSON.parse(basicSetInfo) : {};

    // 判断是否浏览器回退前进进入
    let before_login = JSON.parse(sessionStorage.getItem("BEFORE_LOGIN"));
    if (!before_login || !before_login.userInfoConfim) {
      // this.$router.replace({ path: "/mlogin" });
    } else {
      this.before_login = { ...before_login };
    }

    this.getSelfInfo();
  },

  methods: {
    // 获取自己的密保问题
    async getSelfInfo() {
      const { code, data } = await commonAPI.getAction(`/users/getPwdQuestionByUser/${this.user.username}`);
      if (code == 0) {
        let arr = data || [];
        arr.forEach((el) => {
          this.form.questionVos.push({
            name: el.question,
            question: el.id,
            answer: "",
          });
        });
      }
    },
    // 跳过
    async forgetPass() {
      let params = { status: "2", userName: this.user.username };
      const { code, message } = await commonAPI.postAction("/users/fyw/confirm", params);
      if (code == 101) {
        this.before_login.userInfoConfim = false;
        sessionStorage.setItem("BEFORE_LOGIN", JSON.stringify(this.before_login));
        this.jumpComputed();
      } else {
        toast(message);
      }
    },
    onSubmit() {
      let form = this.form;
      let params = {
        status: "1",
        userName: this.user.username,
        mobile: form.sjh,
        questionVos: [],
      };
      if (form.questionVos.length) {
        form.questionVos.forEach((el) => {
          params.questionVos.push({ question: el.question, answer: el.answer });
        });
      }
      (async () => {
        const { code, message } = await commonAPI.postAction("/users/fyw/confirm", params);
        if (code == 0) {
          toast(message);
          this.before_login.userInfoConfim = false;
          sessionStorage.setItem("BEFORE_LOGIN", JSON.stringify(this.before_login));
          this.jumpComputed();
        } else {
          toast(message);
        }
      })();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/base.scss";
</style>
